import React from 'react'
import { Image, Tooltip, Space } from 'antd';
import './index.css'

type props = {
  text: string,
  pics: Array<string>,
}

const SPTuwen: React.FC<props> = (props) => {
  const { text, pics } = props
  return <div className='introduction-section'>
    {
      text ?
      <div className='introduction-text'>
        <Tooltip overlayInnerStyle={{width: '600px'}} title={text}>
          {text}
        </Tooltip>
      </div>
        : null
    }
    {
      pics?.length ?
        <div className='introduction-pics'>
          {
            pics.map((item, i) => {
              return <div className='introduction-pic-box'>
                <Image
                  className={`introduction-pic ${i === 0 ? 'first' : ''}`}
                  src={item}
                />
              </div>
            })
          }
        </div>
        : null
    }
  </div>
}

export default SPTuwen;
